// src/pages/ConfirmarAssinatura.jsx
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ConfirmarAssinatura = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { nomeCompleto, email, telefone, tipoAssinatura } =
    location.state || {};
  const valorFinal = 19.9;

  if (!email || !nomeCompleto || !telefone || !tipoAssinatura) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
        <div className="bg-white rounded-lg p-6 w-full max-w-md text-red-700">
          <h2 className="text-xl font-bold mb-4">Erro de Acesso</h2>
          <p>
            Dados de cadastro incompletos. Por favor, refaça o cadastro rápido.
          </p>
          <button
            onClick={() => navigate('/cadastro-rapido')}
            className="mt-4 bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
          >
            Voltar para o Cadastro Rápido
          </button>
        </div>
      </div>
    );
  }

  const iniciarPagamento = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await fetch(
        'https://us-central1-elioncadastro.cloudfunctions.net/api/criarAssinatura',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            nomeCompleto,
            email,
            telefone,
            tipoAssinatura,
          }),
        }
      );

      const data = await response.json();

      if (response.ok && data.url) {
        window.location.href = data.url; // Redireciona para o ambiente seguro do Stripe
      } else {
        throw new Error(data.error || 'Erro ao gerar o link de pagamento.');
      }
    } catch (err) {
      setError('Erro ao iniciar pagamento: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6">
      <div className="bg-white rounded-xl p-8 shadow-md w-full max-w-md">
        <h1 className="text-2xl font-bold mb-4 text-center">
          Confirme sua assinatura
        </h1>

        <div className="text-left text-sm mb-4 text-gray-700">
          <p>
            Olá, <strong>{nomeCompleto}</strong>!
          </p>
          <p>
            Seu e-mail: <strong>{email}</strong>
          </p>
          <p>
            Você está prestes a ativar sua <strong>{tipoAssinatura}</strong> no
            valor de <strong>R$ {valorFinal.toFixed(2)}</strong>.
          </p>
          <p className="mt-2 text-gray-500">
            Ao confirmar, você será redirecionado(a) para o ambiente seguro do
            Stripe para finalizar o pagamento.
          </p>
        </div>

        {error && <p className="text-red-600 text-sm mb-4">{error}</p>}

        <button
          onClick={iniciarPagamento}
          disabled={loading}
          className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2 rounded transition disabled:opacity-50"
        >
          {loading ? 'Redirecionando...' : 'Confirmar e Ativar Minha Conta'}
        </button>
      </div>
    </div>
  );
};

export default ConfirmarAssinatura;
